<template>
  
  <div v-if="value">
    {{ label }}
    <!-- <v-layout wrap> -->
    <!-- <v-flex xs12 sm8 v-if="language.language === 'en'">
        <v-textarea v-model="value[field]" :label="label" :rules="rules" :disabled="disabled"></v-textarea>
      </v-flex>-->
    <!-- <v-flex xs12 sm8> -->
    <!-- <quill-editor
          ref="quillEditor"
          v-model="
            value.Translations.filter(
              (o) => o.LanguageCode === language.language
            )[0][field]
          "
          :disabled="disabled"
          :options="editorOption"
        >
          <div id="toolbar" slot="toolbar">
            <button class="ql-custom-button" @click="customButtonClick">
              [ Click me ]
            </button>
          </div>
        </quill-editor> -->
    <!-- <v-textarea
          v-model="value.Translations.filter(o=>o.LanguageCode === language.language)[0][field]"
          :label="label"
          :rules="rules"
          :disabled="disabled"
        ></v-textarea> -->
    <!-- </v-flex> -->
    <!-- <v-flex xs12 sm4 v-if="languages.length > 1">
        <v-btn
          @click="showTrans = !showTrans"
          depressed
          small
          color="success"
          :disabled="disabled"
        >
          <v-icon>language</v-icon>
        </v-btn>
      </v-flex> -->
    <!-- </v-layout>
    <div v-if="showTrans"> -->
    <!-- <v-layout wrap v-if="language.language !== 'en'">
        <v-flex xs12 sm8>
          <v-textarea v-model="value[field]" :label="$t('components.transtextbox.'+label, 'en')" :rules="rules" :disabled="disabled"></v-textarea>
        </v-flex>
      </v-layout>
      <div v-else>-->
    <template v-for="(lang, index) of languages">
      <v-layout wrap :key="index">
        <v-flex xs12 sm8>
          <!-- <v-textarea
              v-model="value.Translations.filter(o=>o.LanguageCode === lang.language)[0][field]"
              :label="$t('components.transtextbox.'+label, lang.language)"
              :rules="rules"
              :disabled="disabled"
            ></v-textarea> -->
          {{ lang.title }}
          <quill-editor
            :ref="quillRef(index)"
            v-model="
              value.Translations.filter(
                (o) => o.LanguageCode === lang.language
              )[0][field]
            "
            :disabled="disabled"
            :options="editorOption"
          />
        </v-flex>
      </v-layout>
    </template>
    <!-- </div> -->
    <v-dialog scrollable v-model="linkDialog" persistent max-width="500">
      <v-card v-if="link !== null && link !== undefined">
        <v-card-title class="headline">{{
          $t("components.transtexteditor.link")
        }}</v-card-title>
        <v-card-text>
          <v-container fluid fill-height>
            <v-flex md12>
              <v-form ref="linkForm" v-model="valid">
                <v-checkbox
                  :label="$t('components.transtexteditor.is_button')"
                  v-model="link.isButton"
                ></v-checkbox>
                <no-autocomplete-textfield
                  :label="$t('components.transtexteditor.url')"
                  v-model="link.url"
                ></no-autocomplete-textfield>
              </v-form>
            </v-flex>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="cancel" text>
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="saveLink" :disabled="!valid">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  <!-- </div> -->
</template>

<script>

// import Parchment from "parchment";
import { mapGetters } from "vuex";
import { translate } from "../trans";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
export default {
  name: "trans-texteditor",
  props: ["value", "rules", "label", "disabled", "field", "dialog"],
  components:{
    NoAutocompleteTextfield
  },
  mounted() {
    this.createTranslations();
    // for (let i = 0; i < this.languages.length; i++) {
    //   let quillref = this.$refs[this.quillRef(i)];
    //   var toolbar = quillref[0].quill.getModule("toolbar");
    //   toolbar.addHandler("link", (v) => {
    //     this.customLinkHandler(v, i);
    //   });
    // }
    

    this.$nextTick(() => {
      for (let i = 0; i < this.languages.length; i++) {
        let quillref = this.$refs[this.quillRef(i)];

        if (Array.isArray(quillref)) {
          quillref = quillref[0];
        }

        //console.log(quillref);
        var themeButton = quillref.$el.querySelector(".ql-theme-btn");
        const listener = function() {
          var range = quillref.quill.getSelection();
          if (range) {
            quillref.quill.formatText(range, "theme-btn");
          }
        };

        themeButton.addEventListener("click", listener);
        this.themeButtonListeners.push({ themeButton, listener });
      }
    });
  },
  beforeDestroy() {
    this.themeButtonListeners.forEach(({ themeButton, listener }) => {
      themeButton.removeEventListener("click", listener);
    });
  },
  data() {
    return {
      quill: null,
      linkDialog: false,
      valid: false,
      link: null,
      editorData: "<p>Rich-text editor content.</p>",
      showTrans: true,
      editorOption: {
        modules: {
          // toolbar: {
          //   handlers: {
          //     // handlers object will be merged with default handlers object
          //     link: function(value) {
          //       console.log("link: ", value);
          //       if (value) {
          //         var href = prompt("Enter the URL");
          //         this.quill.format("link", href);
          //       } else {
          //         this.quill.format("link", false);
          //       }
          //     },
          //   },
          // },
          toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ direction: "rtl" }], // text direction

            [{ size: ["small", false, "large", "huge"] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],

            ["clean"], // remove formatting button
            ["link", "image", "video"],
            ["theme-btn"],
          ],
        },
      },
      themeButtonListeners: []
    };
  },
  computed: {
    ...mapGetters("common", ["language", "languages"]),
    currentLanguageIndex() {
      //console.log(this.languages, this.value);
      if (this.languages && this.languages.length > 1) {
        const langs = this.languages.filter(
          (o) => o.language === this.language.language
        );
        //console.log(langs);
        if (langs.length > 0) return this.languages.indexOf(langs[0]);
      }
      return -1;
    },
    currentTranslationsIndex() {
      //console.log(this.languages, this.value);
      // console.log(
      //   this.value.Translations.filter((o) => o.LanguageCode === "fr")
      // );
      if (this.value.Translations && this.value.Translations.length > 1) {
        const langs = this.value.Translations.filter(
          (o) => o.LanguageCode === this.language.language
        );
        //console.log(langs);
        if (langs.length > 0) return this.value.Translations.indexOf(langs[0]);
      }
      // console.log(
      //   this.value.Translations.filter((o) => o.LanguageCode === "fr")
      // );
      return -1;
    },
  },
  watch: {
    value: {
      handler() {
        this.createTranslations();
        //console.log(this.label);
      },
    },
    dialog: {
      handler(v) {
        if (!v) this.showTrans = false;
      },
    },
  },
  methods: {
    cancel() {
      this.link = null;
      this.linkDialog = false;
    },
    quillRef(index) {
      const name = "quillEditor" + index.toString();
      //console.log(name);
      return name;
    },
    // customButtonClick() {
    //   let quill = this.$refs.quillEditor.quill;
    //   var range = quill.getSelection({ focus: true });
    //   console.log("clicked: ", range);
    //   if (range) {
    //     const text = quill.getText(range.index, range.length);
    //     quill.deleteText(range.index, range.length);
    //     quill.insertText(
    //       range.index,
    //       '<div class="theme-btn">' + text + "</div>"
    //     );
    //   }
    // },
    customLinkHandler(value, quillRefIndex) {
      //console.log("link: ", value, quillRefIndex);
      if (value) {
        this.quill = this.$refs[this.quillRef(quillRefIndex)][0].quill;
        this.link = {};
        this.linkDialog = true;
      } else {
        this.quill.format("link", false);
        this.quill = null;
        this.link = null;
      }
    },
    saveLink() {
      if (this.link.isButton) {
        const range = this.quill.getSelection({ focus: true });
        // console.log("clicked: ", range);
        if (range) {
          this.quill.formatText(range.index, range.length, "theme-btn");
          // const text = this.quill.getText(range.index, range.length);

          // let ThemeBtn = new Parchment.Attributor.Class("theme-btn", "theme-btn");
          // Parchment.register(ThemeBtn);

          // let btn = document.createElement("div");
          // btn.innerHTML = '<a href="'+this.link.url+'">'+text+'</a>';
          // ThemeBtn.add(btn, "theme-btn");
          // console.log(btn.outerHTML); // Will print <div class="blot-align-right"></div>

          // // const btn = '<div class="theme-btn">' + text + '</div>';

          // this.quill.deleteText(range.index, range.length);

          // this.quill.insertEmbed(
          //   range.index,
          //   btn
          // );
          // quill.setSelection(range.index, btn.length)
          // this.quill.format("class", "theme-btn")

          // this.quill.formatText(range.index, range.length, {
          //   class: "theme-btn",
          //   link: this.link.url,
          // });

          // var quill = new Quill('#editor', {
          //   theme: 'snow',
          //   modules: {
          //     toolbar: [
          //       ['theme-btn']
          //     ]
          //   }
          // });
          this.quill.format("theme-btn");
        }
      } else {
        this.quill.format("link", this.link.url);
      }
      this.linkDialog = false;
      //console.log(this.quill.getContents());
    },
    createTranslations() {
      //console.log(this.languages);
      for (const lang of this.languages) {
        //console.log(lang);
        if (!this.value.Translations) this.value.Translations = [];
        if (
          lang.language !== "en" &&
          this.value.Translations.filter(
            (o) => o.LanguageCode === lang.language
          ).length === 0
        ) {
          //console.log(lang);
          this.value.Translations.push({
            LanguageCode: lang.language,
          });
        }
      }
    },
    trans(item) {
      return translate(item, this.language.language);
    },
  },
};
</script>
<style>
.theme-btn {
  cursor: pointer;
  background-color: #444;
  border: none;
  box-shadow: none;
  color: #fff;
  padding: 5px 20px;
  text-transform: uppercase;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  color: #ffffff;
  margin: 5px;
  display: inline-block;
}

.theme-btn a {
  text-decoration: none !important;
  color: #fff !important;
}

.theme-btn:hover {
  text-decoration: none !important;
}

.ql-theme-btn {
  width: 60px !important;
}
.ql-theme-btn:before {
  content: "Btn";
}
</style>
